import * as React from 'react';

interface GameBlockProps {
  character?: string;
  classNames: string[];
}

class GameBlock extends React.Component<GameBlockProps> {
  render(): React.ReactNode {
    const classNames = ['block', ...this.props.classNames];
    return <div className={classNames.join(' ')}>{this.props.character}</div>
  }
}

export default GameBlock; 